import { render, staticRenderFns } from "./UsersSvg.vue?vue&type=template&id=27ef87f7"
import script from "./UsersSvg.vue?vue&type=script&lang=js"
export * from "./UsersSvg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports